import React from 'react'

const Homepage = () => {
  return (
    <section id="homePage">
        <figure>
        <img src='/images/homeImg.jpg' alt='Artemest trade program' />
        <figcaption>
          <h6>Trade</h6>
          <h1>Welcome To Artemest Trade Program</h1>
          <p>Discover your exclusive Trade benefits and unlock the full Artemest experience for Design professionals</p>
        </figcaption>
        </figure>
    </section>
  )
}

export default Homepage;
